import * as z from "zod";

export const getLoopIntegration = {
  name: "getLoopIntegration" as const,
  input: z.object({}),
  output: z.object({
    loopIntegration: z.optional(
      // The access token is write-only: report only whether one is stored.
      z.object({ enabled: z.boolean(), hasAccessToken: z.boolean() }),
    ),
  }),
};

export type GetLoopIntegrationOutput = z.infer<
  typeof getLoopIntegration.output
>;

export const setLoopIntegration = {
  name: "setLoopIntegration" as const,
  input: z.object({
    enabled: z.boolean().optional().default(true),
    accessToken: z.string().min(1, "Access token is required"),
  }),
  output: z.object({}),
};

export const updateLoopIntegration = {
  name: "updateLoopIntegration" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    accessToken: z.string().min(1, "Access token is required").optional(),
  }),
  output: z.object({}),
};

export const disconnectLoopIntegration = {
  name: "disconnectLoopIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
